module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_8003.d04ecc16.png";